<ion-content scrollY="false">
  <ion-list lines="full">

    @if (permissionService.isPermitted('pos-orders-fulfillments-print-packing-slip') && (printer_paper_sizes && printer_paper_sizes.includes('a4'))) {
      <ion-item button="true" (click)="printPackingSlip()">
        <ion-label><fa-icon [icon]="['fal', 'print']" size="lg" [fixedWidth]="true"></fa-icon>Print packing slip</ion-label>
      </ion-item>
    }

    @if (permissionService.isPermitted('pos-orders-fulfillments-print-delivery-note') && (printer_paper_sizes && printer_paper_sizes.includes('a4'))) {
      <ion-item button="true" (click)="printDeliveryNote()">
        <ion-label><fa-icon [icon]="['fal', 'print']" size="lg" [fixedWidth]="true"></fa-icon>Print delivery note</ion-label>
      </ion-item>
    }

    @if (permissionService.isPermitted('pos-orders-fulfillments-print-collection-note') && (printer_paper_sizes && printer_paper_sizes.includes('a4'))) {
      <ion-item button="true" (click)="printCollectionNote()">
        <ion-label><fa-icon [icon]="['fal', 'print']" size="lg" [fixedWidth]="true"></fa-icon>Print collection note</ion-label>
      </ion-item>
    }

    @if (permissionService.isPermitted('pos-orders-fulfillments-edit-fulfillment')) {
      <ion-item button="true" (click)="presentOrderFulfillmentEditModal()">
        <ion-label><fa-icon [icon]="['fal', 'pencil']" size="lg" [fixedWidth]="true"></fa-icon>Edit</ion-label>
      </ion-item>
    }

  </ion-list>
</ion-content>
